import React from 'react'
import Image from 'next/image'
import { RIGHT_CHEVRON_URL, PHONE_CALL_URL, RIGHT_ARROW_URL } from '@constants/contactUs.constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS } from '@configs/contactus.config'
import styles from './styles.module.scss'

const handleTapEvent = async () => {
  await trackEvent(CONTACT_US_EVENTS.MOBILE_TAP.eventName, {
    journey: 'contact_us',
    platform: getDevicePlatform(),
  })
}

const renderPhoneCTA = (cta, isMobile) => (
  <>
    <span className={styles.cardText}>{cta.Title}</span>
    {isMobile ? (
      <div className={styles.cardActionDetails}>
        <div className={styles.cardActionTextWrapper}>
          <a
            href={`tel:${cta.Link}`}
            className={styles.cardLinkText}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleTapEvent}>
            {cta.Link}
          </a>
        </div>
        <a
          href={`tel:${cta.Link}`}
          className={styles.cardIconLink}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={handleTapEvent}>
          <Image src={PHONE_CALL_URL} alt="phone-call" width={16} height={16} />
        </a>
      </div>
    ) : (
      <div className={styles.cardLinkDesktop}>
        <span className={styles.cardLinkText}>{cta.Link}</span>
      </div>
    )}
  </>
)

const renderEmailCTA = (cta, isMobile, isHalfWidth) => (
  <>
    <span className={styles.cardText}>{cta.Title}</span>
    <div
      className={isHalfWidth ? '' : styles.fullWidthCardLinkRow}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}>
      <a
        href={`mailto:${cta.Link}`}
        className={styles.cardLink}
        rel="noopener noreferrer"
        style={{ flex: 1 }}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={handleTapEvent}>
        {cta.Link}
      </a>
      {isMobile ? (
        <Image
          src={RIGHT_ARROW_URL}
          alt="right-arrow"
          width={16}
          height={16}
          style={{ marginLeft: '8px', flexShrink: 0 }}
        />
      ) : (
        !isHalfWidth && (
          <a
            href={`mailto:${cta.Link}`}
            className={styles.fullWidthCardArrow}
            rel="noopener noreferrer"
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleTapEvent}>
            <Image
              src={RIGHT_CHEVRON_URL}
              alt="right-chevron"
              width={24}
              height={24}
              style={{ marginLeft: '8px', flexShrink: 0 }}
            />
          </a>
        )
      )}
    </div>
  </>
)

export const ctaRenderers = {
  Phone: renderPhoneCTA,
  Email: renderEmailCTA,
}
